function getMediaSize(): string {
  // Get the Window With & Height
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  let size = null;

  if (width >= 1440) {
    size = 'xlarge';
  } else if (width >= 1024) {
    size = 'large';
  } else if (width >= 730) {
    size = 'medium';
  } else {
    size = 'small';
  }

  return size;
}

export default getMediaSize;
